export default "__VITE_ASSET__CMnXKygg__"